import React from "react"

import { Tooltip, Button } from "@material-ui/core"
import { FileCopyOutlined } from "@material-ui/icons"
import { Notification } from "@/components"

import copy from "copy-to-clipboard"
import useStyles from "@/pages/Admin/TrackableLinks/TrackableLinksTable/CopyTrackableLinkTableButton/styles"
import newColors from "@/styles/newColors"
import { FormattedLinkToCopy } from ".."

type CopyTrackableLinkButtonProps = {
	formattedLinkToCopy: FormattedLinkToCopy
}

const CopyTrackableLinkTableButton: React.FC<CopyTrackableLinkButtonProps> = (props) => {
	const { formattedLinkToCopy } = props
	const classes = useStyles()

	const copyHandler = () => {
		copy(formattedLinkToCopy.linkToBeCopied)
		Notification.success({ message: "Link copiado com sucesso!" })
	}

	return (
		<Tooltip title="Copiar link">
			<Button
				variant="contained"
				className={classes.button}
				size="small"
				onClick={copyHandler}
				startIcon={
					<FileCopyOutlined
						style={{ fontSize: 16, color: newColors.purple[500] }}
					/>
				}
			>
				<span className={classes.copyButtonText}>
					{formattedLinkToCopy.text}
				</span>
			</Button>
		</Tooltip>
	)
}

export default CopyTrackableLinkTableButton
